export const STATUSES = [
  {
    id: 'canceled',
    value: 'canceled',
    label: 'Canceled',
  },
  {
    id: 'processing',
    value: 'processing',
    label: 'Processing',
  },
  {
    id: 'requires_action',
    value: 'requires_action',
    label: 'Requires action',
  },
  {
    id: 'requires_capture',
    value: 'requires_capture',
    label: 'Requires capture',
  },
  {
    id: 'requires_confirmation',
    value: 'requires_confirmation',
    label: 'Requires confirmation',
  },
  {
    id: 'requires_payment_method',
    value: 'requires_payment_method',
    label: 'Requires payment method',
  },
  {
    id: 'succeeded',
    value: 'succeeded',
    label: 'Succeeded',
  },
];
